import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';
import type { SharedReference } from '~/exportReport/template/noteDefinitions';
import { ExportReportDetailRowComponent } from './exportReportDetailRow.component';

const sectionStyle = css({
  cursor: 'default',
  marginTop: 20,
});

const subHeaderStyle = (theme: Theme) => css({
  fontSize: 13,
  fontWeight: 700,
  color: theme.reportColors.textPrimary,
  margin: '10px 0 4px',
});

type ExportReportNotesAndReferencesProps = Readonly<{
  notes: ReadonlyArray<string>;
  references: ReadonlyArray<SharedReference>;
}>;

export const ExportReportNotesAndReferencesComponent = ({ notes, references }: ExportReportNotesAndReferencesProps) => {
  const hasNotes = notes.length > 0;
  const hasReferences = references.length > 0;

  if (!hasNotes && !hasReferences) {
    return null;
  }

  return (
    <div css={sectionStyle}>
      {hasNotes && (
        <div>
          <div css={subHeaderStyle}>Notes</div>
          {notes.map((note, i) => (
            <ExportReportDetailRowComponent
              key={i}
              index={i + 1}
              text={note}
            />
          ))}
        </div>
      )}

      {hasReferences && (
        <div>
          <div css={subHeaderStyle}>References</div>
          {references.map((ref, i) => (
            <ExportReportDetailRowComponent
              key={i}
              index={i + 1}
              text={ref.text}
              url={ref.url}
            />
          ))}
        </div>
      )}
    </div>
  );
};
